import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ReservationStatus extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  description: string;
}
